/**
 * TEMPLATE-SURVEY-OPTIONS.WIDGET
 * Shared template options for template and survey-level overrides
 */

import Checkbox from "@/components/checkbox"
import TextInput from "@/components/text-input"
import { TemplateOptions } from "@/redux/template.types"
import { WithTranslation, withTranslation } from "react-i18next"

interface OwnProps {
  connectedAsSupervisor: boolean
  supervisorLevel: number
  options: TemplateOptions
  status?: string
  autosaveIsGollac?: boolean
  onChange: (options: TemplateOptions) => void
  onSave: (options: TemplateOptions) => void
}

type Props = OwnProps & WithTranslation

function TemplateSurveyOptionsWidget(props: Props) {
  const { t } = props

  function updateOption(key: string, value: any, autosave = false) {
    const nextOptions = Object.assign({}, props.options, { [key]: value }) as TemplateOptions

    props.onChange(nextOptions)
    if (autosave) props.onSave(nextOptions)
  }

  function editParticipationMinOverride(value: string) {
    const participationMin = Number.parseInt(value, 10)
    updateOption("participationMinOverride", Number.isNaN(participationMin) ? 5 : Math.max(1, participationMin))
  }

  return (
    props.connectedAsSupervisor && props.supervisorLevel === 3 && (
      <>
        <div className="height-20" />

        <p className="grey-t">
          <b>Gestionnaire IDTree uniquement</b>
        </p>

        <Checkbox
          onClick={(e: any) => updateOption("isGollac", e.value, props.autosaveIsGollac)}
          active={props.options.isGollac}
          status={props.autosaveIsGollac ? props.status : undefined}
          text={t("template_options_is_gollac")}
        />

        <Checkbox
          onClick={(e: any) => updateOption("participationMinOverrideEnabled", e.value, true)}
          active={props.options.participationMinOverrideEnabled}
          status={props.status}
          text={t("template_options_participation_min_override_enabled")}
        />

        {props.options.participationMinOverrideEnabled && (
          <>
            <div className="height-10" />

            <TextInput
              type="number"
              min={1}
              value={props.options.participationMinOverride}
              title={t("template_options_participation_min_override")}
              help={t("template_options_participation_min_override_help")}
              status={props.status}
              width={220}
              onBlur={() => props.onSave(props.options)}
              onChange={(e: any) => editParticipationMinOverride(e.value)}
            />
          </>
        )}
      </>
    )
  )
}

export default withTranslation()(TemplateSurveyOptionsWidget)
